import useLocationAggregator from '../../hooks/useLocationAggregator';

interface LocationCountProps {
  locationIdentifiers: [string] | [string, string];
  filterByState?: string;
  prefix?: string;
  suffix?: string;
  showCountThreshold?: number;
  replaceCountWith?: string;
}

function LocationCount({ locationIdentifiers, filterByState, prefix, suffix, showCountThreshold, replaceCountWith}: LocationCountProps) {
  const filter = filterByState ? { states: [filterByState] } : undefined;
  const { count, isLoading } = useLocationAggregator({ locationIdentifiers, filter });

  if (isLoading || !count || (showCountThreshold !== undefined && count < showCountThreshold)) {
    return null;
  }

  return (
    <>
      {prefix && prefix}
      {replaceCountWith ? replaceCountWith : count}
      {suffix && suffix}
    </>
  );
}

export default LocationCount;
